import { apiSlice } from "./apiSlice";
import { ENGLISHQUESTIONGROUP_URL } from "../constants";

export const englishQuestionGroupApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createEnglishQuestionGroup: builder.mutation({
      query: (data) => ({
        url: ENGLISHQUESTIONGROUP_URL,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["EnglishQuestionGroup"],
    }),

    getEnglishQuestionGroupsByChapter: builder.query({
      query: (chapterId) => ({
        url: `${ENGLISHQUESTIONGROUP_URL}/chapter/${chapterId}`,
      }),
      providesTags: (result, error, chapterId) => [
        {
          type: "EnglishQuestionGroup",
          id: `CHAPTER-${chapterId}`,
        },
      ],
      keepUnusedDataFor: 5,
    }),

    getEnglishQuestionGroupsBySubject: builder.query({
      query: (subjectId) => ({
        url: `${ENGLISHQUESTIONGROUP_URL}/subject/${subjectId}`,
      }),
      providesTags: (result, error, subjectId) => [
        {
          type: "EnglishQuestionGroup",
          id: `SUBJECT-${subjectId}`,
        },
      ],
      keepUnusedDataFor: 5,
    }),

    getEnglishQuestionGroupAvailability: builder.query({
      query: ({ chapter, groupType, selectionMode }) => ({
        url: `${ENGLISHQUESTIONGROUP_URL}/availability`,
        params: {
          chapter,
          groupType,
          selectionMode,
        },
      }),
      keepUnusedDataFor: 5,
    }),

    getQuestionsByEnglishQuestionGroup: builder.query({
      query: (groupId) => ({
        url: `${ENGLISHQUESTIONGROUP_URL}/${groupId}/questions`,
      }),
      providesTags: (result, error, groupId) => [
        {
          type: "EnglishQuestionGroupQuestions",
          id: groupId,
        },
      ],
      keepUnusedDataFor: 5,
    }),

    recalculateEnglishQuestionGroup: builder.mutation({
      query: (groupId) => ({
        url: `${ENGLISHQUESTIONGROUP_URL}/${groupId}/recalculate`,
        method: "POST",
      }),
      invalidatesTags: (result, error, groupId) => [
        "EnglishQuestionGroup",
        {
          type: "EnglishQuestionGroup",
          id: groupId,
        },
        {
          type: "EnglishQuestionGroupQuestions",
          id: groupId,
        },
      ],
    }),

    toggleEnglishQuestionGroupStatus: builder.mutation({
      query: (groupId) => ({
        url: `${ENGLISHQUESTIONGROUP_URL}/${groupId}/status`,
        method: "PATCH",
      }),
      invalidatesTags: (result, error, groupId) => [
        "EnglishQuestionGroup",
        {
          type: "EnglishQuestionGroup",
          id: groupId,
        },
      ],
    }),

    getEnglishQuestionGroupById: builder.query({
      query: (groupId) => ({
        url: `${ENGLISHQUESTIONGROUP_URL}/${groupId}`,
      }),
      providesTags: (result, error, groupId) => [
        {
          type: "EnglishQuestionGroup",
          id: groupId,
        },
      ],
      keepUnusedDataFor: 5,
    }),

    updateEnglishQuestionGroup: builder.mutation({
      query: ({ groupId, ...data }) => ({
        url: `${ENGLISHQUESTIONGROUP_URL}/${groupId}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, error, { groupId }) => [
        "EnglishQuestionGroup",
        {
          type: "EnglishQuestionGroup",
          id: groupId,
        },
        {
          type: "EnglishQuestionGroupQuestions",
          id: groupId,
        },
      ],
    }),

    deleteEnglishQuestionGroup: builder.mutation({
      query: (groupId) => ({
        url: `${ENGLISHQUESTIONGROUP_URL}/${groupId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["EnglishQuestionGroup"],
    }),
  }),
});

export const {
  useCreateEnglishQuestionGroupMutation,
  useGetEnglishQuestionGroupsByChapterQuery,
  useGetEnglishQuestionGroupsBySubjectQuery,
  useGetEnglishQuestionGroupAvailabilityQuery,
  useGetQuestionsByEnglishQuestionGroupQuery,
  useRecalculateEnglishQuestionGroupMutation,
  useToggleEnglishQuestionGroupStatusMutation,
  useGetEnglishQuestionGroupByIdQuery,
  useUpdateEnglishQuestionGroupMutation,
  useDeleteEnglishQuestionGroupMutation,
  useLazyGetEnglishQuestionGroupsBySubjectQuery,
} = englishQuestionGroupApiSlice;